(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ilmm-collection-search"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ilmm-collection-search')) {
    class IlmmCollectionSearch extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.form = this.querySelector('form');
        this.input = this.querySelector('input');
        this.clearButton = this.querySelector('.ilmm-search-clear');
        this.status = this.querySelector('.ilmm-search-status');
        this.results = this.querySelector('.ilmm-search-results');
        this.original = this.nextElementSibling;
        if (!this.original || !this.original.classList.contains('product_c')) return;
        this.sequence = 0;
        this.hidden = false;
        this.form.addEventListener('submit', event => {
          event.preventDefault();
          this.run(this.input.value, true);
        });
        this.clearButton.addEventListener('click', () => {
          this.run('', true);
          this.input.focus();
        });
        this.onHistory = () => this.run(new URL(location.href).searchParams.get('collection_query') || '', false);
        window.addEventListener('popstate', this.onHistory);
        this.onHistory();
      }

      disconnectedCallback() {
        window.removeEventListener('popstate', this.onHistory);
        this.ready = false;
      }

      normalize(value) {
        return String(value).normalize('NFKC').toLowerCase().replace(/[×✕✖]/g, 'x').replace(/センチ(?:メートル)?|cm/g, '').replace(/\s*x\s*/g, 'x').trim();
      }

      async loadProducts() {
        if (this.productsPromise) return this.productsPromise;
        this.productsPromise = (async () => {
          const current = new URL(location.href);
          let url = new URL(this.dataset.collectionUrl, location.origin);
          url.searchParams.set('view', 'ilmm-search');
          for (const key of ['sort_by', 'preview_theme_id']) {
            if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
          }
          const products = [];
          const seenPages = new Set();
          const seenProducts = new Set();
          while (url) {
            if (url.origin !== location.origin || seenPages.has(url.href)) throw new Error('Invalid collection page');
            seenPages.add(url.href);
            const response = await fetch(url.href, { credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(20000) });
            if (!response.ok) throw new Error('Collection could not be loaded');
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const source = doc.querySelector('[data-ilmm-search-source]');
            if (!source || source.dataset.collectionId !== this.dataset.collectionId) throw new Error('Collection source mismatch');
            for (const card of source.querySelectorAll('[data-ilmm-product]')) {
              if (seenProducts.has(card.dataset.ilmmProduct)) continue;
              seenProducts.add(card.dataset.ilmmProduct);
              products.push({ card, text: this.normalize(card.dataset.searchText) });
            }
            if (source.dataset.next) {
              url = new URL(source.dataset.next, url);
              url.searchParams.set('view', 'ilmm-search');
              for (const key of ['sort_by', 'preview_theme_id']) {
                if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
              }
            } else {
              url = null;
            }
          }
          return products;
        })().catch(error => {
          this.productsPromise = null;
          throw error;
        });
        return this.productsPromise;
      }

      async run(value, updateHistory) {
        const requestId = ++this.sequence;
        const query = value.trim();
        this.input.value = query;
        if (updateHistory) {
          const url = new URL(location.href);
          if (query) url.searchParams.set('collection_query', query);
          else url.searchParams.delete('collection_query');
          if (url.href !== location.href) history.pushState(null, '', url);
        }
        this.clearButton.hidden = !query;
        this.results.replaceChildren();
        this.results.hidden = true;
        if (!query) {
          this.original.hidden = false;
          this.status.textContent = '';
          this.removeAttribute('aria-busy');
          return;
        }
        this.original.hidden = true;
        this.setAttribute('aria-busy', 'true');
        this.status.textContent = this.dataset.loading;
        try {
          const products = await this.loadProducts();
          if (requestId !== this.sequence) return;
          const words = this.normalize(query).split(/\s+/).filter(Boolean);
          const matches = words.length ? products.filter(product => words.every(word => product.text.includes(word))) : [];
          this.results.replaceChildren(...matches.map(product => product.card.cloneNode(true)));
          this.results.hidden = false;
          this.status.textContent = this.dataset.count.replace('__COUNT__', String(matches.length)).replace('__TERM__', () => query);
        } catch (error) {
          if (requestId !== this.sequence) return;
          this.original.hidden = false;
          this.status.textContent = this.dataset.error;
        } finally {
          if (requestId === this.sequence) this.removeAttribute('aria-busy');
        }
      }
    }
    customElements.define('ilmm-collection-search', IlmmCollectionSearch);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ilmm-site-search-form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ilmm-site-search')) {
    customElements.define('ilmm-site-search', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const select = this.querySelector('select');
        const input = this.querySelector('input[type=search]');
        select.addEventListener('change', () => {
          input.placeholder = select.value === 'article' ? input.dataset.articlePlaceholder : input.dataset.productPlaceholder;
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ilmm-site-search-results"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ilmm-site-results')) {
    customElements.define('ilmm-site-results', class extends HTMLElement {
      connectedCallback() {
        const url = new URL(location.href);
        const type = url.searchParams.get('type');
        if (url.searchParams.get('q') && type !== 'product' && type !== 'article') {
          url.searchParams.set('type', 'product');
          url.searchParams.delete('page');
          location.replace(url.href);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
